import { Button, Callout, Modal } from '@dev-spendesk/grapes';

import { CompanyBankInformation } from 'common/components/CompanyBankInformation';
import { useTranslation } from 'common/hooks/useTranslation';

import { type Account } from '../../wallet';

type Props = {
  account: Account;
  country: string;
  onClose: () => void;
};

export const TopUpModal = ({ account, country, onClose }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen
      iconName="banknote"
      iconVariant="info"
      title={t('wallet.topUp.modal.title')}
      onClose={onClose}
      actions={[
        <Button
          key="close"
          text={t('wallet.topUp.modal.closeButton')}
          variant="primaryBrand"
          onClick={onClose}
        />,
      ]}
    >
      <div className="flex flex-col gap-16">
        <p className="body-m text-content-secondary">
          {t('wallet.topUp.modal.description')}
        </p>
        <Callout
          title={t('wallet.topUp.modal.instantPaymentInfo')}
          variant="info"
        />
        <CompanyBankInformation
          account={account}
          country={country}
          displayTitleAndFooter={false}
        />
      </div>
    </Modal>
  );
};
